// Customer links on a shop's tracking hostname: track.twigs.net/<code> and
// track.twigs.net/r/<code>. Codes are 10 characters holding a capital letter
// and a digit (older tracking links used 32+ hex characters). ROSA page paths
// are lowercase words, so neither shape can be mistaken for one.
const TRACKING_CODE = /^\/(?:[a-f0-9]{32,64}|(?=[A-Za-z0-9]*[A-Z])(?=[A-Za-z0-9]*[2-9])[A-Za-z0-9]{10})\/?$/;
const REVIEW_CODE = /^\/r\/[A-Za-z0-9]{8,16}\/?$/;

export const isTrackingCodePath = (pathname) => TRACKING_CODE.test(pathname || '');
export const isReviewCodePath = (pathname) => REVIEW_CODE.test(pathname || '');
